export default function hasAnyRole(roles, requiredRoles) {
  return roles.some((role) => requiredRoles.includes(role));
}
